function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 64.5254,
  cy: 53.1387,
  r: 53.1387,
  fill: "#E6EEFC"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_0:1669)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.6201 48.8686C25.6201 42.3178 30.9306 37.0073 37.4814 37.0073H118.138C124.689 37.0073 130 42.3178 130 48.8686C130 55.4195 124.689 60.73 118.138 60.73H37.4814C30.9306 60.73 25.6201 55.4195 25.6201 48.8686Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M112.833 48.8687L115.728 45.9317C115.83 45.8283 115.83 45.6607 115.728 45.5573C115.626 45.4539 115.461 45.4539 115.359 45.5573L112.464 48.4943L109.57 45.5573C109.468 45.4539 109.302 45.4539 109.2 45.5573C109.099 45.6607 109.099 45.8283 109.2 45.9317L112.095 48.8687L109.2 51.8057C109.099 51.9091 109.099 52.0767 109.2 52.1801C109.251 52.2318 109.318 52.2576 109.385 52.2576C109.452 52.2576 109.519 52.2318 109.57 52.1801L112.464 49.2431L115.359 52.1801C115.41 52.2318 115.477 52.2576 115.543 52.2576C115.61 52.2576 115.677 52.2318 115.728 52.1801C115.83 52.0767 115.83 51.909 115.728 51.8057L112.833 48.8687Z",
  fill: "#333333"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 38.1455,
  y: 48.0215,
  width: 50.1022,
  height: 3.38895,
  rx: 1.69447,
  fill: "#E3E8F1"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 17.5547C0 11.0038 5.31049 5.69336 11.8613 5.69336H68.7956C75.3464 5.69336 80.6569 11.0038 80.6569 17.5547C80.6569 24.1055 75.3464 29.416 68.7956 29.416H11.8613C5.31049 29.416 0 24.1055 0 17.5547Z",
  fill: "#ACCDFB"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M67.5846 17.5547L70.497 14.6178C70.5996 14.5144 70.5996 14.3467 70.497 14.2433C70.3945 14.1399 70.2283 14.1399 70.1257 14.2433L67.2132 17.1803L64.3008 14.2433C64.1982 14.1399 64.032 14.1399 63.9294 14.2433C63.8269 14.3467 63.8269 14.5144 63.9294 14.6178L66.8419 17.5547L63.9294 20.4917C63.8269 20.5951 63.8269 20.7627 63.9294 20.8661C63.9807 20.9178 64.0479 20.9437 64.1151 20.9437C64.1823 20.9437 64.2495 20.9178 64.3008 20.8661L67.2132 17.9292L70.1257 20.8661C70.177 20.9178 70.2442 20.9437 70.3114 20.9437C70.3786 20.9437 70.4458 20.9178 70.497 20.8661C70.5996 20.7627 70.5996 20.5951 70.497 20.4917L67.5846 17.5547Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 13.4424,
  y: 15.8604,
  width: 28.566,
  height: 3.38895,
  rx: 1.69447,
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 31.3135,
  y: 67.3723,
  width: 71.1679,
  height: 23.7226,
  rx: 11.8613,
  fill: "#ACCDFB"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 41.3604,
  y: 77.5391,
  width: 28.4672,
  height: 3.38895,
  rx: 1.69447,
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M85.2689 79.2337L88.1713 76.2967C88.2735 76.1933 88.2735 76.0257 88.1713 75.9223C88.0691 75.8189 87.9035 75.8189 87.8013 75.9223L84.8989 78.8592L81.9965 75.9223C81.8943 75.8189 81.7286 75.8189 81.6264 75.9223C81.5243 76.0257 81.5243 76.1933 81.6264 76.2967L84.5288 79.2337L81.6264 82.1706C81.5243 82.274 81.5243 82.4417 81.6264 82.5451C81.6775 82.5968 81.7445 82.6226 81.8115 82.6226C81.8784 82.6226 81.9454 82.5968 81.9965 82.5451L84.8989 79.6081L87.8013 82.5451C87.8524 82.5968 87.9193 82.6226 87.9863 82.6226C88.0533 82.6226 88.1202 82.5968 88.1713 82.5451C88.2735 82.4417 88.2735 82.274 88.1713 82.1706L85.2689 79.2337Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_0:1669",
  x: 21.6201,
  y: 33.0073,
  width: 112.38,
  height: 31.7227,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.7963 0 0 0 0 0.832193 0 0 0 0 0.900391 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_0:1669"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_0:1669",
  result: "shape"
})));

var SvgTagsEmptyStateIllustration = function SvgTagsEmptyStateIllustration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 107,
    viewBox: "0 0 134 107",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTagsEmptyStateIllustration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Tags_empty_state_illustration.7ad67f12.svg";
export { ForwardRef as ReactComponent };